import {Component, Input, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'business-order-create-multilayer-warning',
    templateUrl: './business-order-create-multilayer-warning.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BusinessOrderCreateMultilayerWarningComponent {
  @Input() invalidML = false;
  @Input() errorMl?: string = null;
}
